import { axiosAjax } from '@app/src/config/axios';
import { MyAnnouncementModel } from '@app/src/views/MyAccount/listAvailable/models/AnnouncementModel';
import { hydrateData } from './hydrators';
import { isClientEnv } from '@app/src/utils/validations';

export const serviceAnnouncement = {
  async post(userId: string, json: any): Promise<MyAnnouncementModel> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.post(
        process.env.API_MY_ANNOUNCEMENT_PAGINATOR
          .replace(':userId', userId), json, config);
      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data);
    } catch (e) {
      console.log(`Error announcement service: ${e}`);
      throw new Error(e);
    }
  },
  async delete(json): Promise<any[]> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.put(process.env.API_ANNOUNCEMENT_DELETE, json, config);
      if (data.error) {
        throw new Error();
      }
      return data.data;
    } catch (e) {
      throw new Error(e);
    }
  },
  async setInactive(json): Promise<any[]> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.put(process.env.API_ANNOUNCEMENT_INACTIVE, json, config);
      if (data.error) {
        throw new Error();
      }
      return data.data;
    } catch (e) {
      throw new Error(e);
    }
  },
  async getRepublish(userId: string, categoryId: number, uniqueId: string): Promise<any[]> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.get(
        process.env.API_ANNOUNCEMENT_REPUBLISH
          .replace(':userId', userId)
          .replace(':categoryId', String(categoryId))
          .replace(':uniqueId', uniqueId),
          config
      );
      if (data.error) {
        throw new Error();
      }
      return data.data;
    } catch (e) {
      throw new Error(e);
    }
  },
}
